import { render, staticRenderFns } from "./CultureV2.vue?vue&type=template&id=826560a8&scoped=true"
import script from "./CultureV2.vue?vue&type=script&lang=js"
export * from "./CultureV2.vue?vue&type=script&lang=js"
import style0 from "./CultureV2.vue?vue&type=style&index=0&id=826560a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826560a8",
  null
  
)

export default component.exports